
import { useDispatch, useSelector } from 'react-redux';
import { updateFilterValues } from "../../store/features/searchSlice";
import { RootState } from '../../store/store';
import { DropdownSelectOption } from '../../constants/common';
import { ProductCategory } from '../../constants/products';
import { useHandleSearch } from '../../store/features/searchSlice';


export interface FooterElementProps {
    text: string,
    link: string,
}

export const FooterElement: React.FC<FooterElementProps> = ({ text, link }) => {

    return (
        <div className='text-light font-light text-sm hover:underline hover:text-primary'>
            <a href={link} onClick={() => {window.scrollTo(0, 0)}}>
                {text}
            </a>

        </div>
    )
}

